import { ArrowRightCircle, Home, Smile } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-main-bg text-dark flex flex-col items-center justify-center py-16 px-4 relative overflow-hidden">
     
      <div className="text-center relative z-10">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
        >
          <Smile className="text-accent w-24 h-24 mx-auto mb-6" />
        </motion.div>
        
        <h1 className="text-5xl md:text-6xl font-poppins font-bold text-primary mb-4">
          ¡Oops! Página no encontrada
        </h1>
        
        <p className="text-xl font-montserrat text-dark mb-8 max-w-2xl mx-auto">
          Parece que te has salido del camino médico, pero no te preocupes. ¡Nuestro equipo está listo para guiarte de vuelta!
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
          <Link
            to="/"
            className="inline-flex items-center justify-center bg-primary text-main-bg py-3 px-6 rounded-lg font-poppins hover:bg-accent transition-colors duration-300 transform hover:scale-105 text-center"
          >
            <Home className="w-6 h-6 mr-2" />
            Volver al Inicio
          </Link>
          
          <Link
            to="/contacto"
            className="inline-flex items-center justify-center bg-secondary text-main-bg py-3 px-6 rounded-lg font-poppins hover:bg-dark transition-colors duration-300 transform hover:scale-105 text-center"
          >
            <ArrowRightCircle className="w-6 h-6 mr-2" />
            Contactar Soporte
          </Link>
        </div>
        
        <p className="text-sm font-montserrat text-dark mt-8">
          ¿Necesitas ayuda inmediata? Llámanos al +1 809 555 1234
        </p>
      </div>
    </div>
  );
};